import { render, staticRenderFns } from "./_CustomSelect.vue?vue&type=template&id=2364ecc7"
import script from "./_CustomSelect.vue?vue&type=script&lang=ts"
export * from "./_CustomSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports